<template>
  <div class="disc-card">
    <div
      class="disc-card__body"
      v-if="getIsApostilleService"
      v-html="getSettingNote.apostille_disclosure_note"
    ></div>
    <div
      class="disc-card__body"
      v-else
      v-html="getSettingNote.finra_disclosure_note"
    ></div>

    <div class="disc-accept">
      <input
        type="checkbox"
        class="disc-accept__checkbox"
        @change="acceptTerms"
        v-model="check1"
        id="check-accept"
      />
      <label for="check-accept" class="disc-accept__label">
        I accept these terms and conditions.
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      check1: false
    };
  },
  computed: {
    ...mapGetters(["getSettingNote", "getIsApostilleService"])
  },
  methods: {
    acceptTerms() {
      this.$emit("term", this.check1);
    }
  }
};
</script>

<style lang="scss">
$teal:      #5bb8b1;
$teal-dark: #2c7d76;
$dark:      #1a1a2e;
$gray:      #6c7280;
$font:      'Segoe UI', system-ui, sans-serif;

.disc-card {
  background: #fff;
  border-radius: 14px;
  border: 1.5px solid rgba(91, 184, 177, 0.2);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  font-family: $font;

  &__body {
    padding: 20px;
    max-height: 55vh;
    overflow-y: auto;
    font-size: 14px;
    color: $dark;
    line-height: 1.7;

    @media (min-width: 768px) { padding: 28px; font-size: 15px; }

    p, li { color: $dark; margin-bottom: 10px; }
    h1, h2, h3, h4 { color: $teal-dark; margin-bottom: 10px; }
    strong { color: $dark; }

    &::-webkit-scrollbar { width: 5px; }
    &::-webkit-scrollbar-track { background: #f0f9f8; border-radius: 4px; }
    &::-webkit-scrollbar-thumb { background: $teal; border-radius: 4px; }
  }
}

.disc-accept {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid rgba(91, 184, 177, 0.18);
  background: rgba(91, 184, 177, 0.03);

  @media (min-width: 768px) { padding: 18px 28px; }

  &__checkbox {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    cursor: pointer;
    accent-color: $teal;
  }

  &__label {
    font-size: 14px;
    font-weight: 600;
    color: $dark;
    cursor: pointer;
    margin: 0;
    user-select: none;
  }
}
</style>
